import type { AppEnv } from "@mube/config"

export const PUBLIC_CONFIG_SCRIPT_ID = "mube-public-config"

const LESS_THAN_PATTERN = /</g
const LESS_THAN_ESCAPE = "\\u003c"

export interface PublicConfig {
  readonly apiBaseUrl: string
  readonly supabaseUrl: string
  readonly supabasePublishableKey: string
  readonly siteUrl: string
  readonly defaultTimeZone: string
  readonly sentryDsn: string | undefined
  readonly sentryReplayOnErrorSampleRate: number | undefined
  readonly telemetryEnabled: boolean
  readonly appEnv: AppEnv
  readonly appVersion: string | undefined
  readonly mediaMasterMaxLongSide: number
  readonly mediaMaxBytesPhoto: number
  readonly mediaMaxBytesFloorplan: number
  readonly webFlowPropertiesEnabled: boolean
  readonly webFlowToursEnabled: boolean
  readonly webFlowBillingEnabled: boolean
  readonly webFlowTeamEnabled: boolean
}

export function serializePublicConfig(config: PublicConfig): string {
  return JSON.stringify(config).replace(LESS_THAN_PATTERN, LESS_THAN_ESCAPE)
}

export function readPublicConfig(document_: Document | undefined): PublicConfig | undefined {
  if (document_ === undefined) {
    return undefined
  }
  const text = document_.getElementById(PUBLIC_CONFIG_SCRIPT_ID)?.textContent
  if (text === null || text === undefined || text === "") {
    return undefined
  }
  try {
    return JSON.parse(text) as PublicConfig
  } catch {
    return undefined
  }
}
